import React from "react";

function ImpactCounter({ icon, iconStyle, counter, desc }) {
  return (
    <div>
      {React.cloneElement(icon, { ...iconStyle }, null)}
      <div>{`${counter}+`}</div>
      <div>{desc}</div>
    </div>
  );
}

export default ImpactCounter;
